import { CallBackUrlAvailableProps } from "../bootstrap/bootstrap-types";
export const urlParameters = () => {
  const str = window.location.search;

  const secureURLLocal = localStorage.getItem("Cloud_SecureURL");

  if (str) {
    const queryString = str;
    const queryStringObj = Object.fromEntries(new URLSearchParams(queryString));
    localStorage.setItem("Cloud_SecureURL", JSON.stringify(queryStringObj));

    return queryStringObj;
  }

  if (secureURLLocal) {
    return JSON.parse(secureURLLocal);
  }
};

export const getSecureUrl = () => {
  const secureUrls = window.location.pathname;
  if (secureUrls) {
    return secureUrls;
  }
};

export const getLandingPage = () => {
  const urlPage = window.location.href;
  const url = urlPage.split("&");
  return url[2];
};

export const getPageUrl = () => {
  const urlPage = window.location.href;
  const url = urlPage.split("/");
  return url[3];
};
export const parseURL = (callback_url: any) => {
  return callback_url.includes("https://") ? callback_url : `https://${callback_url}`;
};
export const secondsToHms = (d: any) => {
  d = Number(d);

  const m = Math.floor((d % 3600) / 60);
  const s = Math.floor((d % 3600) % 60);

  const mDisplay = m > 0 ? formatTime(m) + ":" : "00:";
  const sDisplay = s > 0 ? formatTime(s) : "00";
  return mDisplay + sDisplay;
};

export const formatTime = (time: number) => {
  if (time < 10) {
    return `0${time}`;
  }
  return time;
};

export const redirectLogInPage = () => {
  const parameters = urlParameters();
  if (!parameters) {
    return;
  }
  const callBack_Url = parameters.callback_url;
  const auth_Token = parameters.auth_token;

  if (auth_Token && callBack_Url) {
    return true;
  }

  if (!auth_Token && !callBack_Url) {
    return false;
  }
};

export const authTokenAvailable = () => {
  const parameters = urlParameters();
  if (!parameters) {
    return;
  }
  const auth_Token = parameters.auth_token;

  if (auth_Token) {
    return auth_Token;
  }
};

export const consumerIdAvailable = () => {
  const parameters = urlParameters();
  if (!parameters) {
    return;
  }
  const consumer_id = parameters.consumer_id;

  if (consumer_id) {
    return consumer_id;
  }
};

export const callBackUrlAvailable = (): CallBackUrlAvailableProps => {
  const landingPage = getLandingPage();
  const parameters = urlParameters();
  if (!parameters) {
    return;
  }
  const callBack_Url = parameters.callback_url;

  if (callBack_Url) {
    return `${callBack_Url}?${landingPage}`;
  } else {
    return false;
  }
};

export const getTransactionsProp = () => {
  return JSON.parse(localStorage.getItem("Transactions_Props") || "{}");
};

export const getSendTransferProps = () => {
  return JSON.parse(localStorage.getItem("SendTransfer_Props") || "{}");
};

export const getAccessToken = () => {
  const items = JSON.parse(localStorage.getItem("activeUser") || "{}");

  return items && items.access_token;
};

export const getProfileData = () => {
  return JSON.parse(localStorage.getItem("userProfile") || "{}");
};

export const getConsumerId = () => {
  const items = getProfileData();

  return (items && items?.id) || "";
};

export const getUserEntity = () => {
  const profile = getProfileData();
  return (profile && profile?.entityType) || "";
};

export const getUserFirstName = () => {
  const items = getProfileData();

  if (items?.entityType === "CONSUMER") {
    return `${items?.firstName} ${items.lastName}`;
  } else {
    return items?.firstName;
  }
};

export const getTransferFundsTo = () => {
  const items = JSON.parse(localStorage.getItem("TransferFunds_Props") || "{}");

  return items?.state?.record;
};
